/**
 * @generated SignedSource<<2d339c00db3e862c5da2439307063057>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuildProblemsPreviewDependencyIdsFragment$data = {
  readonly build: ReadonlyArray<{
    readonly rawId: number | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "BuildProblemsPreviewDependencyIdsFragment";
};
export type BuildProblemsPreviewDependencyIdsFragment$key = {
  readonly " $data"?: BuildProblemsPreviewDependencyIdsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuildProblemsPreviewDependencyIdsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildProblemsPreviewDependencyIdsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Build",
      "kind": "LinkedField",
      "name": "build",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rawId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Builds",
  "abstractKey": null
};

(node as any).hash = "cb79774e9573c71892ac287639b6151b";

export default node;
